<div class="mask  d-flex justify-content-center align-items-center">
    <div class="container mt-5 pt-5">
        <section>
            <div class="row">
                <div class="col-12">
                    <div class="card z-depth-2">
                        <div class="card-body p-0">

                            <div class="row mx-0">

                                <div class="col-lg-6 py-5 px-md-5 d-none d-lg-block">
                                    <div class="view">
                                        <img src="../../../../../assets/img/ForgotPassword.svg" class="img-fluid mt-lg-5"
                                            alt="Trakly Login">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-12 cloudy-knoxville-gradient accent-3 py-5 px-md-5">
                                    <form class="text-center border border-light p-5 w-100" (ngSubmit)="ResetPassword()">
                                        <img src="../../../../../assets/img/Trakly_Logo_3.png" class="img-fluid" alt="Responsive image">
                                        <p class="h4 mb-4">Password Reset</p>
                
                                        <!-- Email -->
                                        <div class="md-form">
                                            <input type="email" id="materialLoginFormEmail" class="form-control" mdbInput
                                                [(ngModel)]="email" name="email">
                                            <label for="materialLoginFormEmail">E-mail</label>
                                        </div>
                
                                        <!--Error Display-->
                                        <div *ngIf="showError" class="alert alert-danger" role="alert">
                                            {{ errorMsg }}
                                        </div>
                
                                        <!--Success Display-->
                                        <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                            If an account exists for that email, a one-time password has been sent. Redirecting...
                                        </div>
                
                                        <!-- Sign in button -->
                                        <button *ngIf="!busy" mdbBtn color="trakly" block="true" class="my-4" type="submit">Reset Password</button>
                                        
                                        <!--Loading display-->
                                        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                
                                        <div class="d-flex justify-content-around">
                                            <div>
                                                <!-- Forgot password -->
                                                <a href="/">Back to Login</a>
                                            </div>
                                        </div>
                                    </form>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </section>

    </div>

</div>
